import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

export const usePostPatientTreatmentStart = () => {
  const client = useApiClient();

  return useMutation<void, Error, number>({
    mutationFn: (patientID: number) => client.postPatientTreatmentStart(patientID),
  });
};
